import api from './api';

// PUBLIC
export const getServers = async () => {
  const res = await api.get('/refurbished-servers');
  return res.data;
};

export const getServerById = async (id) => {
  const res = await api.get(`/refurbished-servers/${id}`);
  return res.data;
};

// ADMIN
export const getAllServersAdmin = async () => {
  const res = await api.get('/refurbished-servers/admin/all');
  return res.data;
};

export const createServer = async (payload) => {
  const res = await api.post('/refurbished-servers', payload);
  return res.data;
};

export const updateServer = async (id, payload) => {
  const res = await api.patch(`/refurbished-servers/${id}`, payload);
  return res.data;
};

export const deleteServer = async (id) => {
  const res = await api.delete(`/refurbished-servers/${id}`);
  return res.data;
};

// NEW — uploads up to 6 images, returns their Cloudinary URLs
export const uploadServerImages = async (files) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append('images', file));

  const res = await api.post('/refurbished-servers/upload-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { success, urls }
};